module.exports = __webpack_public_path__ + "img/bg1.2fd5deef.jpg";